/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @group Constants
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 * 
 * @example
 * ```typescript
 * import { ROUTE_RESOURCES } from '@shared/utils';
 * 
 * // Use route resource constants
 * const resource = ROUTE_RESOURCES.API_DATA_USERS;
 * ```
 */
export const ROUTE_RESOURCES = {
  API_AUTH_____NEXTAUTH_: 'api/auth/[...nextauth]' as const,
  API_AUTH_ONBOARDING_START: 'api/auth/onboarding/start' as const,
  API_AUTH_SIGNIN: 'api/auth/signin' as const,
  API_AUTH_SIGNOUT: 'api/auth/signout' as const,
  API_AUTH_SIGNUP: 'api/auth/signup' as const,
  API_CONTACT: 'api/contact' as const,
  API_DATA_DELETE_REQUEST: 'api/data/delete-request' as const,
  API_DATA_DELETE_REQUEST_CONFIRM: 'api/data/delete-request/confirm' as const,
  API_DATA_EHR_INTEGRATIONS: 'api/data/ehr-integrations' as const,
  API_DATA_HEALTH_RECORD_UPLOADS: 'api/data/health-record-uploads' as const,
  API_DATA_HOME: 'api/data/home' as const,
  API_DATA_PATIENT_PROFILES: 'api/data/patient-profiles' as const,
  API_DATA_PATIENT_PROFILES__ID_: 'api/data/patient-profiles/[id]' as const,
  API_DATA_PAYMENT_METHODS: 'api/data/payment-methods' as const,
  API_DATA_PAYMENT_METHODS__ID_: 'api/data/payment-methods/[id]' as const,
  API_DATA_PAYMENT_METHODS__ID__SET_DEFAULT: 'api/data/payment-methods/[id]/set-default' as const,
  API_DATA_PAYMENT_METHODS_INITIALIZE: 'api/data/payment-methods/initialize' as const,
  API_DATA_PAYMENT_METHODS_VERIFY: 'api/data/payment-methods/verify' as const,
  API_DATA_PERMISSIONS: 'api/data/permissions' as const,
  API_DATA_PERMISSIONS__ID_: 'api/data/permissions/[id]' as const,
  API_DATA_ROLES: 'api/data/roles' as const,
  API_DATA_ROLES__ID_: 'api/data/roles/[id]' as const,
  API_DATA_TENANTS: 'api/data/tenants' as const,
  API_DATA_TENANTS__ID_: 'api/data/tenants/[id]' as const,
  API_DATA_USERS: 'api/data/users' as const,
  API_DATA_USERS__ID_: 'api/data/users/[id]' as const,
  API_DISTRIBUTOR_PATIENTS: 'api/distributor/patients' as const,
  API_EHR_VITALS: 'api/ehr/vitals' as const,
  API_EHR_VITALS_SUBMIT: 'api/ehr/vitals/submit' as const,
  API_MOBILE_VERSION_GATE: 'api/mobile/version-gate' as const,
  API_SCANNER_RESULTS: 'api/scanner/results' as const,
  API_SCANNER_SESSIONS: 'api/scanner/sessions' as const,
  API_SHENAI_TOKEN: 'api/shenai/token' as const,
  API_TELEHEALTH_CLINICIANS: 'api/telehealth/clinicians' as const,
  API_TELEHEALTH_CONFERENCE: 'api/telehealth/conference' as const,
  API_TELEHEALTH_JOIN: 'api/telehealth/join' as const,
  API_TELEHEALTH_QUEUE: 'api/telehealth/queue' as const,
  API_TELEHEALTH_QUEUE__CONSULTATIONID_: 'api/telehealth/queue/[consultationId]' as const,
  API_TELEHEALTH_QUEUE__CONSULTATIONID__END: 'api/telehealth/queue/[consultationId]/end' as const,
  API_TELEHEALTH_QUEUE__CONSULTATIONID__START: 'api/telehealth/queue/[consultationId]/start' as const,
  API_TELEHEALTH_QUEUE__CONSULTATIONID__STATUS: 'api/telehealth/queue/[consultationId]/status' as const,
  API_TELEHEALTH_SESSIONS: 'api/telehealth/sessions' as const,
  API_WEBHOOKS_PAYSTACK: 'api/webhooks/paystack' as const,
} as const;